import { Matters, Apply, ProInsight, SMartTip } from "@utils/defaultImages";

export const getFoodData = (data, t) => {
  if (!data) return [];

  return [
    {
      label: t("1. Why It Matters"),
      key: "setup",
      icon: <Matters className="w-[34px] h-[34px]" />,
      tabColor: "#F0FFFF",
      value: data?.["Why It Matters"],
    },
    {
      label: t("2. How to Apply It"),
      key: "focus",
      icon: <Apply className="w-[34px] h-[34px]" />,
      tabColor: "#F0FFFF",
      value: data?.["How to Apply It"],
    },
    {
      label: t("3. Smart Tip"),
      key: "awareness",
      icon: <SMartTip className="w-[34px] h-[34px]" />,
      tabColor: "#F0FFFF",
      value: data?.["Smart Tip"],
    },
    {
      label: t("4. Pro Insight"),
      key: "gentle_return",
      icon: <ProInsight className="w-[34px] h-[34px]" />,
      tabColor: "#F0FFFF",
      value: data?.["Pro Insight"],
    },
  ];
};
